<div class="relative inline-block">
  <div class="language-select flex items-center" #dropdownTrigger>
    <div class="current-language-wrapper grow-0">
      <div
        class="current-language flex align-items-center justify-content-center"
      >
        <span>
          {{ displaySelectedLanguage }}
        </span>
      </div>
    </div>
    <div
      class="flex-grow-1 flex justify-content-center"
      (click)="toggleLanguagesDropdown()"
    >
      <mat-icon
        class="stroke-blue-30 arrow"
        [svgIcon]="'arrow-down-thin'"
      ></mat-icon>
    </div>
  </div>
  <ng-template #dropdownTemplate>
    <div
      class="absolute w-[9.063rem] p-2 right-4 rounded-xl bg-white shadow-sm border-2 border-grey-10"
    >
      @for (availableLanguage of availableLanguages; track availableLanguage) {
      <div
        class="language-option px-3 py-2 rounded-xl cursor-pointer text-left font-edenred"
        [class.selected-language]="
          availableLanguage.name === selectedLanguage?.name
        "
        (click)="onLanguageSelect(availableLanguage)"
      >
        {{ availableLanguage.displayName }}
      </div>
      }
    </div>
  </ng-template>
</div>
